module.exports = __webpack_public_path__ + "img/date-red.9f5db5b2.svg";